import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { BookDemoForm } from "../components/BookDemoForm";

export default function BookDemoPage() {
  return (
    <div className="bg-white" data-testid="book-demo-page">
      <Navbar />
      <section className="pt-32 md:pt-40 pb-14 bg-gradient-to-b from-[#f5f5f7] to-white">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <div className="overline">Book a Demo</div>
          <h1 className="h1-hero text-5xl md:text-7xl mt-4">
            Experience it first.
            <br />
            <span className="text-[#FF6A13]">Then decide.</span>
          </h1>
          <p className="mt-5 text-lg text-[#86868B] max-w-xl mx-auto">
            Live machine demonstration at your site. A specialist will call you
            back within one business day.
          </p>
        </div>
      </section>
      <section className="py-10 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <BookDemoForm />
        </div>
      </section>
      <Footer />
    </div>
  );
}
